var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sd-live sd-pill--dark"},[_c('div',{staticClass:"sd-shape-circle"}),_c('p',{staticClass:"sd-live__text"},[_vm._v(_vm._s(_vm.$t('live').toUpperCase()))])])}
var staticRenderFns = []

export { render, staticRenderFns }